import { Amplify, Auth, Storage } from 'aws-amplify';

// import { BucketName, AmplifyConfigure } from '../Utils/baseURL';

import portalEnvironment from '../Utils/baseURL';

Amplify.configure({
  Auth: {
    identityPoolId: portalEnvironment.AmplifyConfigure.identityPoolId,
    region: portalEnvironment.AmplifyConfigure.region,
    userPoolId: portalEnvironment.AmplifyConfigure.userPoolId,
    userPoolWebClientId: portalEnvironment.AmplifyConfigure.userPoolWebClientId,
    mandatorySignIn: false,
    oauth: {
      domain: 'portal-direcional-dev.auth.us-east-1.amazoncognito.com',
      redirectSignIn: 'http://localhost:3000/interna',
      redirectSignOut: 'http://localhost:3000',
      responseType: 'token',
    },
  },
  Analytics: {
    disabled: true,
  },
  Storage: {
    AWSS3: {
      bucket: portalEnvironment.BucketName,
      region: portalEnvironment.AmplifyConfigure.region,
    },
  },
});

const Cognito = {
  signUp: async (username, password, email, phone_number) => {
    try {
      await Auth.signUp({
        username,
        password,
        attributes: {
          email,
          phone_number,
        },
      });
    } catch (error) {
      return error;
    }
  },

  confirmSignUp: async (username, code) => {
    try {
      await Auth.confirmSignUp(username, code);
    } catch (error) {
      return error;
    }
  },

  signIn: async (username, password) => {
    try {
      return await Auth.signIn(username, password);
    } catch (error) {
      return error;
    }
  },

  socialSignIn(provider) {
    (async function () {
      await Auth.federatedSignIn({ provider });
    })();
  },

  signOut: async () => {
    await Auth.signOut();

    // sessionStorage.clear();

    localStorage.removeItem('token');

    sessionStorage.removeItem('token');

    localStorage.removeItem('idTokenSens');

    sessionStorage.removeItem('idTokenSens');

    localStorage.removeItem('idtoken');

    sessionStorage.removeItem('idtoken');

    localStorage.removeItem('imoveis');

    sessionStorage.removeItem('qtdAgdm');

    sessionStorage.removeItem('imovelAtual');

    localStorage.removeItem('tempToken');
  },

  //softsignout para mudança de e-mail. UTILIZAR SOMENTE NESTE CASO
  softSignOut: async () => {
    await Auth.signOut();
  },

  forgotPassword: async (user) => {
    await Auth.forgotPassword(user);
  },

  confirmForgotPassword: async (user, code, pass) => {
    return Auth.forgotPasswordSubmit(user, code, pass);
  },

  getUser: async () => {
    return Auth.currentAuthenticatedUser();
  },

  changePassword: async (oldPass, newPass) => {
    const user = await Auth.currentAuthenticatedUser();
    const changeResult = await Auth.changePassword(user, oldPass, newPass);
    return changeResult;
  },

  deleteUser: async () => {
    await Auth.currentAuthenticatedUser();
  },

  deleteUser2: async (userCognito) => {
    return await userCognito.deleteUser(() => {});
  },

  resendCode: async (username) => {
    await Auth.resendSignUp(username);
  },

  resendCodeForgotPassword: async (username) => {
    await Auth.resendForgotPassword(username);
  },

  updatePhoto: async (name, file) => {
    try {
      await Storage.put(name, file, {
        contentType: 'image/png', // contentType is optional
        level: 'public',
      });
    } catch (error) {
      return error;
    }
  },
};

export default Cognito;
